import { StyleSheet } from 'aphrodite';
import { titles } from '../../../styles/colors';
import { CssSelectors, Layouts } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	columns: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: 2,
	},
	container: {
		...Layouts.verticalStack(40),
	},
	radioGroup: {
		flexWrap: 'wrap',
		...CssSelectors.allDescendants(
			{
				marginLeft: 15,
				marginRight: -15,
			},
			'.radio-button:nth-child(2n)'
		),
	},
	radioOption: {
		color: '#858585',
		fontSize: 14,
		display: 'block',
	},
	radioOptionSize: {
		marginBottom: 5,
		width: '50%',
	},
	section: {
		...Layouts.verticalStack(15),
	},
	sectionHeader: {
		color: titles,
		fontSize: 18,
	},
	sectionHeaderIcon: {
		height: 20,
		width: 'auto',
	},
	selectBox: {
		width: '100%',
	},
	selectBoxOption: {
		fontSize: 14,
	},
	selectBoxContent: {
		width: '100% !important',
	},
	typeSection: {},
});
